import jiraCloudAppLogo from '@gitlab/svgs/dist/illustrations/third-party-logos/integrations-logos/jira_cloud_app.svg?raw';
import { GlButton, GlEmptyState } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { s__ } from '~/locale';
import HelpPageLink from '../../../vue_shared/components/help_page_link/help_page_link.vue?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    jiraCloudAppLogo,
    name: 'EmptyState',
    components: {
        GlButton,
        GlEmptyState,
        HelpPageLink
    },
    directives: {
        SafeHtml
    },
    inject: [
        'canCreateProjects',
        'newProjectPath',
        'signInPath',
        'isGroup'
    ],
    props: {
        hasProjects: {
            type: Boolean,
            required: false,
            default: false
        },
        hasEpicsFeature: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    computed: {
        showNewProjectButton () {
            return this.canCreateProjects && this.isGroup && !this.hasProjects;
        },
        description () {
            return this.showNewProjectButton && this.hasEpicsFeature ? s__('WorkItem|Use epics to collaborate on ideas, solve problems, and plan work across this group. To track other work items, create a project.') : s__('WorkItem|Use work items (also known as tickets or stories on other platforms) to collaborate on ideas, solve problems, and plan your project.');
        },
        newProjectButtonVariant () {
            // Without epics there is no "New item" button, so "New project" is the only action
            return this.hasEpicsFeature ? 'default' : 'confirm';
        }
    }
};
